export function deleteCookie(name) {
  let domain = location.hostname,
    path = "/"; // root path

  document.cookie = [
    name,
    "=",
    "; expires=" + new Date(0).toUTCString(),
    "; path=" + path,
    "; domain=" + domain,
  ].join("");
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function eraseCookie(name: string) {
  setCookie(name, "", -1);
}
